import whatsApp from '../../../src/assets/images/icon/whatsApp1.svg'
function WhatsApp() {
    return (
        <div className='fixed z-20 bottom-2 right-2 md:right-4 flex flex-col items-center justify-center'>
            <a
                className='flex items-center justify-center rounded-full shadow-xl w-10 h-10 md:w-16 md:h-16 Zhover:cursor-pointer'
                style={{ background: '#00FBC8' }}
                a href={"https://wa.me/51967222918"} 
                target="_blank"
            >
                <img src={whatsApp} />
                <br />
            </a>
            <div className='text-[14px] text-center font-bold'>PowerBizz</div>
        </div>
    )
}

export default WhatsApp